const UserVerificationIcon = ({ className, title }: { className?: string, title: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={49}
        height={48}
        fill="none"
        style={{ stroke: 'var(--w-s-color-icon-primary)' }}
        className={className}
    >
        <title>{title}</title>
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M24.5 3.506A15 15 0 0 0 2 16.5M32.002 16.5a14.956 14.956 0 0 0-1.248-6M17 46.5c1.008 0 2.012-.1 3-.3M2 25.5v6a15 15 0 0 0 9 13.752"
        />
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M26 21v-4.5a9 9 0 0 0-13.5-7.796M8 16.5v15a9 9 0 0 0 12 8.488"
        />
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M14 31.5a3 3 0 0 0 6 0v-15a3 3 0 0 0-6 0v6M36.5 31.5a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5ZM36.5 33A10.5 10.5 0 0 0 26 43.5v3h21v-3A10.497 10.497 0 0 0 36.5 33v0Z"
        />
    </svg>
);
export default UserVerificationIcon;
